import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Zone } from 'libs/ui';
import { Content, Count } from './zone-row.styled';

export const ZoneRow = (props) => {
  const { zone_id, zone_name, limit, maximum, free } = props;
  const { t } = useTranslation();

  const color = useMemo(() => {
    const node = window.config.objects.zones.find((item) => {
      return item.zoneId.toString() === zone_id.toString();
    });
    return node?.color ?? '#fff';
  }, [zone_id]);

  const cntAll = free + ' / ' + limit ?? maximum;

  return (
    <Content>
      <Zone color={color} zoneId={zone_name} />
      <Count>
        <span>{t('tables.Свободно') + ':'}</span>
        <b>{cntAll}</b>
      </Count>
    </Content>
  );
};
